import { Button, Dialog, Intent, Shape } from '@axieinfinity/matcha'

type TWalletLinkModalProps = {
  disabled?: boolean
  visible?: boolean
  onConfirm?: () => void
  onClose?: () => void
}

const WalletLinkModal: React.FC<TWalletLinkModalProps> = ({
  visible,
  disabled,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog
      className="[&_.dango-dialog-content]:bg-surface-color-default [&_.dango-dialog-content]:border [&_.dango-dialog-content]:border-border-color-default [&_.dango-dialog-body]:p-0 [&_.dango-dialog-content]:!p-0 p-16 !w-[390px] sm:!w-[500px]"
      visible={visible}
      onClose={onClose}
      size="small"
    >
      <div className="flex flex-col p-24">
        <div className="mb-12 mt-8 text-h4">Link new wallet confirmation</div>

        <div className="mb-8 text-body-m text-text-color-subdued">
          {`Please check and ensure you are `}
          <span className="text-text-color-default">
            connecting to a correct new wallet
          </span>
          .
        </div>

        <div className="mb-24 text-body-m text-text-color-subdued">
          {`If you previously unlinked a wallet, you need to wait 30 days
          from that date to unlink another one.`}
        </div>

        <div className="flex w-full items-center justify-end gap-16">
          <Button
            shape={Shape.Default}
            onClick={onClose}
            disabled={disabled}
            text="Cancel"
          />

          <Button
            shape={Shape.Default}
            intent={Intent.Primary}
            disabled={disabled}
            onClick={onConfirm}
            text="Continue"
          />
        </div>
      </div>
    </Dialog>
  )
}

export default WalletLinkModal
